import React from "react";

import PropTypes from "prop-types";

const LineItem = ({
	className,
	leftLabel,
	rightLabel,
}) => {
	return (
		<div
			className={`${className} payment-product-line-item`}
		>
			<div
				className="payment-product-line-item-col"
			>
				<span dangerouslySetInnerHTML={{ __html: leftLabel }} />
			</div>
			<div
				className="payment-product-line-item-col"
			>
				<span dangerouslySetInnerHTML={{ __html: rightLabel }} />
			</div>
		</div>
	);
};

LineItem.propTypes = {
	className: PropTypes.string,
	leftLabel: PropTypes.string.isRequired,
	rightLabel: PropTypes.string.isRequired,
};

LineItem.defaultProps = {
	className: "",
};

export default LineItem;



// WEBPACK FOOTER //
// ./src/apps/payment/components/Product/LineItem.jsx